module.exports = __webpack_public_path__ + "static/img/6.c70e618.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/6.png
// module id = lXOB
// module chunks = 0